import React from 'react';
import { Link } from 'react-router-dom';
import { FileTextIcon, PhoneIcon } from 'lucide-react';
import { company } from '../data/site';

/**
 * Barre d'action permanente sur mobile : l'appel et la demande de devis
 * restent accessibles quel que soit le point de lecture de la page.
 */
export function StickyCallBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur lg:hidden" data-id="element-155" data-mp="1r0g4qejlhkdq">
      <div className="flex gap-3" data-id="element-156" data-mp="2jn0y1kjms6jx">
        <a href={company.phoneHref} className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-ember-500 px-4 py-3.5 font-display text-base font-bold text-white transition-colors duration-150 ease-out active:bg-ember-600" data-id="element-157" data-mp="2jo25lf1fuaww">
          <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-158" data-mp="139kh7tm69bca" />
          Appeler
        </a>
        <Link to="/contact" className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-navy-800 px-4 py-3.5 font-display text-base font-bold text-white transition-colors duration-150 ease-out active:bg-navy-700" data-id="element-159" data-mp="y9od7udh5jwq">
          <FileTextIcon className="h-5 w-5" aria-hidden="true" data-id="element-160" data-mp="m4tx27gtnodu" />
          Devis
        </Link>
      </div>
    </div>;
}